import ContactComponent from '@/components/contact/ContactComponent.vue';
import FranchiseComponent from '@/components/franchise/FranchiseComponent.vue';
import HomeComponent from '@/components/home/HomeComponent.vue';
import MenuComponent from '@/components/menu/MenuComponent.vue';
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeComponent,
  },
  {
    path: '/menu',
    name: 'Menu',
    component: MenuComponent,
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactComponent,
  },
  {
    path: '/franchise',
    name: 'Franchise',
    component: FranchiseComponent,
  },

];

export default routes;
